import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-8"
}
const _hoisted_2 = { class: "flex items-start space-x-4 mb-6" }
const _hoisted_3 = { class: "flex-1" }
const _hoisted_4 = { class: "text-lg font-semibold text-primary-text dark:text-primary-dark-text mb-2" }
const _hoisted_5 = { class: "grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" }
const _hoisted_6 = { class: "bg-gradient-to-br from-blue-50 to-indigo-50 dark:from-blue-900/20 dark:to-indigo-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-4" }
const _hoisted_7 = { class: "font-medium text-blue-900 dark:text-blue-100 mb-3 flex items-center" }
const _hoisted_8 = { class: "space-y-2 text-sm" }
const _hoisted_9 = { class: "flex justify-between" }
const _hoisted_10 = { class: "text-blue-900 dark:text-blue-100 font-medium" }
const _hoisted_11 = { class: "flex justify-between" }
const _hoisted_12 = { class: "text-blue-900 dark:text-blue-100 font-medium" }
const _hoisted_13 = { class: "flex justify-between" }
const _hoisted_14 = { class: "text-blue-900 dark:text-blue-100 font-medium" }
const _hoisted_15 = { class: "bg-gradient-to-br from-purple-50 to-violet-50 dark:from-purple-900/20 dark:to-violet-900/20 border border-purple-200 dark:border-purple-800 rounded-lg p-4" }
const _hoisted_16 = { class: "font-medium text-purple-900 dark:text-purple-100 mb-3 flex items-center" }
const _hoisted_17 = { class: "space-y-3" }
const _hoisted_18 = { class: "flex justify-between text-sm" }
const _hoisted_19 = { class: "text-purple-900 dark:text-purple-100 font-medium" }
const _hoisted_20 = { class: "w-full bg-purple-200 dark:bg-purple-800 rounded-full h-3" }
const _hoisted_21 = { class: "text-xs text-purple-600 dark:text-purple-300" }
const _hoisted_22 = { class: "bg-gradient-to-br from-emerald-50 to-teal-50 dark:from-emerald-900/20 dark:to-teal-900/20 border border-emerald-200 dark:border-emerald-800 rounded-lg p-4 mb-6" }
const _hoisted_23 = { class: "font-medium text-emerald-900 dark:text-emerald-100 mb-3 flex items-center" }
const _hoisted_24 = { class: "flex items-center space-x-2" }
const _hoisted_25 = {
  key: 1,
  class: "text-center py-8 mb-8"
}
const _hoisted_26 = { class: "bg-gradient-to-br from-gray-50 to-slate-50 dark:from-gray-800/50 dark:to-slate-800/50 border border-gray-200 dark:border-gray-700 rounded-lg p-8" }
const _hoisted_27 = { class: "text-sm text-slate-500 dark:text-slate-400" }
const _hoisted_28 = {
  key: 2,
  class: "border-t border-gray-200 dark:border-gray-700 pt-6"
}
const _hoisted_29 = { class: "flex items-center justify-between mb-4" }
const _hoisted_30 = { class: "text-lg font-medium text-primary-text dark:text-primary-dark-text flex items-center" }
const _hoisted_31 = ["disabled"]
const _hoisted_32 = {
  key: 0,
  class: "grid grid-cols-2 md:grid-cols-4 gap-4 mb-6"
}
const _hoisted_33 = { class: "bg-gradient-to-br from-blue-50 to-indigo-50 dark:from-blue-900/20 dark:to-indigo-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-4" }
const _hoisted_34 = { class: "text-2xl font-bold text-blue-700 dark:text-blue-300" }
const _hoisted_35 = { class: "bg-gradient-to-br from-emerald-50 to-teal-50 dark:from-emerald-900/20 dark:to-teal-900/20 border border-emerald-200 dark:border-emerald-800 rounded-lg p-4" }
const _hoisted_36 = { class: "text-2xl font-bold text-emerald-700 dark:text-emerald-300" }
const _hoisted_37 = { class: "bg-gradient-to-br from-purple-50 to-violet-50 dark:from-purple-900/20 dark:to-violet-900/20 border border-purple-200 dark:border-purple-800 rounded-lg p-4" }
const _hoisted_38 = { class: "text-2xl font-bold text-purple-700 dark:text-purple-300" }
const _hoisted_39 = { class: "bg-gradient-to-br from-amber-50 to-orange-50 dark:from-amber-900/20 dark:to-orange-900/20 border border-amber-200 dark:border-amber-800 rounded-lg p-4" }
const _hoisted_40 = { class: "text-2xl font-bold text-amber-700 dark:text-amber-300" }
const _hoisted_41 = {
  key: 1,
  class: "space-y-4"
}
const _hoisted_42 = { class: "flex items-center justify-between mb-4 employee-row" }
const _hoisted_43 = { class: "flex items-center space-x-4 employee-info" }
const _hoisted_44 = { class: "relative" }
const _hoisted_45 = { class: "w-12 h-12 rounded-full overflow-hidden bg-gradient-to-br from-primary-accent/20 to-primary-accent/40 flex items-center justify-center border-2 border-primary-accent/30" }
const _hoisted_46 = ["src", "alt"]
const _hoisted_47 = {
  key: 1,
  class: "text-primary-accent dark:text-primary-dark-accent text-lg font-medium"
}
const _hoisted_48 = { class: "flex-1" }
const _hoisted_49 = { class: "font-semibold text-primary-text dark:text-primary-dark-text text-lg" }
const _hoisted_50 = { class: "flex items-center space-x-2 text-sm text-secondary-text dark:text-secondary-dark-text" }
const _hoisted_51 = {
  key: 0,
  class: "flex items-center space-x-2 text-xs text-tertiary-text dark:text-tertiary-dark-text mt-1"
}
const _hoisted_52 = { class: "employee-badge" }
const _hoisted_53 = { class: "status-text" }
const _hoisted_54 = {
  key: 0,
  class: "grid grid-cols-1 md:grid-cols-4 gap-4 rounded-lg p-4"
}
const _hoisted_55 = { class: "flex items-center space-x-3" }
const _hoisted_56 = { class: "text-sm font-medium text-primary-text dark:text-primary-dark-text" }
const _hoisted_57 = {
  key: 0,
  class: "flex items-center space-x-3"
}
const _hoisted_58 = { class: "text-xs text-secondary-text dark:text-secondary-dark-text" }
const _hoisted_59 = {
  key: 1,
  class: "flex items-center space-x-3 opacity-50"
}
const _hoisted_60 = { class: "w-10 h-10 bg-gray-100 dark:bg-gray-800 rounded-lg flex items-center justify-center" }
const _hoisted_61 = { class: "flex items-center space-x-3" }
const _hoisted_62 = { class: "text-lg font-bold text-primary-text dark:text-primary-dark-text" }
const _hoisted_63 = { class: "text-xs text-secondary-text dark:text-secondary-dark-text" }
const _hoisted_64 = { class: "flex items-center space-x-3" }
const _hoisted_65 = { class: "flex-1" }
const _hoisted_66 = { class: "flex items-center space-x-2" }
const _hoisted_67 = { class: "text-xs text-secondary-text dark:text-secondary-dark-text" }
const _hoisted_68 = {
  key: 1,
  class: "bg-gray-50 dark:bg-dark-primary/30 rounded-lg p-4"
}
const _hoisted_69 = { class: "flex items-center justify-center space-x-3 text-gray-500 dark:text-gray-400" }
const _hoisted_70 = {
  key: 2,
  class: "text-center py-8"
}
const _hoisted_71 = { class: "bg-gradient-to-br from-gray-50 to-slate-50 dark:from-gray-800/50 dark:to-slate-800/50 border border-gray-200 dark:border-gray-700 rounded-lg p-8" }
const _hoisted_72 = { class: "text-sm text-slate-500 dark:text-slate-400" }
const _hoisted_73 = {
  key: 3,
  class: "text-center py-8"
}
const _hoisted_74 = {
  key: 4,
  class: "text-center py-8"
}
const _hoisted_75 = { class: "bg-gradient-to-br from-red-50 to-pink-50 dark:from-red-900/20 dark:to-pink-900/20 border border-red-200 dark:border-red-800 rounded-lg p-8" }
const _hoisted_76 = { class: "text-sm text-red-600 dark:text-red-400 mb-4" }

import type { ModuleRotation } from '@/services/modules'
import type { ModuleProgressData } from '@/services/employee-assignment'
import { EmployeeAssignmentService } from '@/services/employee-assignment'
import BaseModal from '@/components/common/BaseModal.vue'
import BaseTooltip from '@/components/common/BaseTooltip.vue'
import { 
  Calendar,
  Clock,
  Info,
  Users,
  User,
  RefreshCw,
  AlertCircle,
  CheckCircle2,
  XCircle,
  Clock3,
  UserCheck,
  UserX,
  Award,
  Target,
  TrendingUp,
  Mail
} from 'lucide-vue-next'
import { ref, watch } from 'vue'

// Define month interface
interface MonthData {
  number: number
  name: string
  module: ModuleRotation | null
  isCurrentMonth: boolean
}

// Props
interface Props {
  show: boolean
  monthData: MonthData | null
  year: number
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ModuleDetailsModal',
  props: {
    show: { type: Boolean },
    monthData: {},
    year: {}
  },
  emits: ["close"],
  setup(__props: any) {

const props = __props

// Emits


// Reactive data for employee progress
const employeeProgress = ref<ModuleProgressData | null>(null)
const loadingProgress = ref(false)
const progressError = ref<string | null>(null)

// Load employee progress when modal is shown and has module data
watch(
  [() => props.show, () => props.monthData?.module?.module_id, () => props.year],
  ([show, moduleId, year]) => {
    if (show && moduleId) {
      loadEmployeeProgress(moduleId, year)
    } else {
      employeeProgress.value = null
      progressError.value = null
    }
  },
  { immediate: true }
)

// Load employee progress
const loadEmployeeProgress = async (moduleId: number, year: number) => {
  if (loadingProgress.value) return
  
  try {
    loadingProgress.value = true
    progressError.value = null
    
    const response = await EmployeeAssignmentService.getModuleEmployeeProgress(
      moduleId, 
      year, 
      props.monthData?.number
    )
    
    employeeProgress.value = response.data
  } catch (error: any) {
    console.error('Failed to load employee progress:', error)
    progressError.value = error.message || 'Failed to load employee progress data'
    employeeProgress.value = null
  } finally {
    loadingProgress.value = false
  }
}

// Refresh employee progress
const refreshEmployeeProgress = async () => {
  if (props.monthData?.module?.module_id) {
    await loadEmployeeProgress(props.monthData.module.module_id, props.year)
  }
}

// Helper function to get month names
const getMonthNames = (months: number[]): string[] => {
  const monthNames = [
    '', 'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ]
  return months.map(month => monthNames[month] || 'Unknown')
}

// Utility methods
const getModuleStatusColor = (module: ModuleRotation): string => {
  if (module.is_current) return 'bg-gradient-to-r from-green-400 to-emerald-500 shadow-lg shadow-green-200 dark:shadow-green-900/50'
  if (module.is_future) return 'bg-gradient-to-r from-blue-400 to-indigo-500 shadow-lg shadow-blue-200 dark:shadow-blue-900/50'
  return 'bg-gradient-to-r from-gray-400 to-slate-500 shadow-lg shadow-gray-200 dark:shadow-gray-900/50'
}

const getModuleStatusTextColor = (module: ModuleRotation): string => {
  if (module.is_current) return 'text-green-700 dark:text-green-300'
  if (module.is_future) return 'text-blue-700 dark:text-blue-300'
  return 'text-gray-600 dark:text-gray-400'
}

const getModuleStatusText = (module: ModuleRotation): string => {
  if (module.is_current) return 'Current Module'
  if (module.is_future) return 'Upcoming Module'
  return 'Past Module'
}

const getProgressBarColor = (module: ModuleRotation): string => {
  if (module.is_current) return 'bg-gradient-to-r from-green-500 to-emerald-500'
  if (module.is_future) return 'bg-gradient-to-r from-blue-500 to-indigo-500'
  return 'bg-gradient-to-r from-gray-400 to-slate-400'
}

const formatDate = (dateString: string): string => {
  const date = new Date(dateString)
  return date.toLocaleDateString('en-US', { 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric' 
  })
}

const getDuration = (startDate: string, endDate: string): string => {
  const start = new Date(startDate)
  const end = new Date(endDate)
  const diffTime = Math.abs(end.getTime() - start.getTime())
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
  return `${diffDays} days`
}

const getMonthProgress = (module: ModuleRotation): number => {
  if (module.is_past) return 100
  if (module.is_future) return 0
  
  // For current module, calculate actual progress
  const start = new Date(module.start_date)
  const end = new Date(module.end_date)
  const now = new Date()
  
  const total = end.getTime() - start.getTime()
  const elapsed = now.getTime() - start.getTime()
  
  return Math.max(0, Math.min(100, Math.round((elapsed / total) * 100)))
}

const getProgressDescription = (module: ModuleRotation): string => {
  if (module.is_past) return 'Module duration completed'
  if (module.is_future) return 'Module duration not started'
  
  const progress = getMonthProgress(module)
  if (progress < 25) return 'Early in the month'
  if (progress < 50) return 'Quarter way through month'
  if (progress < 75) return 'Halfway through month'
  return 'Nearing end of month'
}

// Employee status helper functions
const getEmployeeStatusClass = (employee: any): string => {
  if (!employee.has_access) {
    return 'bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-400 border-gray-300 dark:border-gray-600'
  }
  
  if (!employee.progress.exam_available) {
    return 'bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 border-blue-300 dark:border-blue-600'
  }
  
  if (!employee.progress.exam_taken) {
    return 'bg-amber-100 dark:bg-amber-900/30 text-amber-700 dark:text-amber-300 border-amber-300 dark:border-amber-600'
  }
  
  if (employee.progress.exam_passed) {
    return 'bg-emerald-100 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-300 border-emerald-300 dark:border-emerald-600'
  }
  
  return 'bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-300 border-red-300 dark:border-red-600'
}

const getEmployeeStatusIcon = (employee: any) => {
  if (!employee.has_access) return UserX
  if (!employee.progress.exam_available) return User
  if (!employee.progress.exam_taken) return Clock3
  if (employee.progress.exam_passed) return CheckCircle2
  return XCircle
}

const getEmployeeStatusText = (employee: any): string => {
  if (!employee.has_access) return 'No Access'
  if (!employee.progress.exam_available) return 'Assigned'
  if (!employee.progress.exam_taken) return 'Pending'
  if (employee.progress.exam_passed) return 'Completed'
  return 'Failed'
}

// Get certification tooltip text based on employee progress
const getCertificationTooltip = (employee: any): string => {
  if (!employee.progress.exam_available) {
    return 'No exam is available for this module'
  }
  
  if (!employee.progress.exam_taken) {
    return 'Employee has not yet attempted the exam'
  }
  
  if (employee.progress.exam_passed) {
    return 'This employee has completed the module and passed the exam'
  }
  
  return 'Employee attempted the exam but did not pass'
}

// Handle profile image loading errors
const handleImageError = (event: Event) => {
  const img = event.target as HTMLImageElement
  // Hide the broken image by setting display to none
  // The fallback initials will be shown instead
  img.style.display = 'none'
}

// Ensure scores are displayed as whole numbers and calculate safe percentages
const formatScore = (score?: number | null) => {
  const n = Number(score ?? 0)
  if (Number.isNaN(n)) return 0
  return Math.round(n)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    "is-visible": _ctx.show,
    title: `${_ctx.monthData?.name} ${_ctx.year}`,
    subtitle: "Module rotation details",
    icon: _unref(Calendar),
    size: "2xl",
    type: "default",
    "show-footer": false,
    onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
  }, {
    default: _withCtx(() => [
      (_ctx.monthData?.module)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", {
                class: _normalizeClass(["flex-shrink-0 w-4 h-4 rounded-full mt-1", getModuleStatusColor(_ctx.monthData.module)])
              }, null, 2),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.monthData.module.module_name), 1),
                _createElementVNode("p", {
                  class: _normalizeClass(["text-sm mb-4", getModuleStatusTextColor(_ctx.monthData.module)])
                }, _toDisplayString(getModuleStatusText(_ctx.monthData.module)), 3)
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("h4", _hoisted_7, [
                  _createVNode(_unref(Calendar), { class: "w-4 h-4 mr-2 text-blue-600 dark:text-blue-400" }),
                  _cache[1] || (_cache[1] = _createTextVNode(" Schedule ", -1))
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _cache[2] || (_cache[2] = _createElementVNode("span", { class: "text-blue-600 dark:text-blue-300" }, "Start Date:", -1)),
                    _createElementVNode("span", _hoisted_10, _toDisplayString(formatDate(_ctx.monthData.module.start_date)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text-blue-600 dark:text-blue-300" }, "End Date:", -1)),
                    _createElementVNode("span", _hoisted_12, _toDisplayString(formatDate(_ctx.monthData.module.end_date)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _cache[4] || (_cache[4] = _createElementVNode("span", { class: "text-blue-600 dark:text-blue-300" }, "Duration:", -1)),
                    _createElementVNode("span", _hoisted_14, _toDisplayString(getDuration(_ctx.monthData.module.start_date, _ctx.monthData.module.end_date)), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("h4", _hoisted_16, [
                  _createVNode(_unref(Clock), { class: "w-4 h-4 mr-2 text-purple-600 dark:text-purple-400" }),
                  _cache[5] || (_cache[5] = _createTextVNode(" Time Progress ", -1))
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _cache[6] || (_cache[6] = _createElementVNode("span", { class: "text-purple-600 dark:text-purple-300" }, "Month Duration:", -1)),
                    _createElementVNode("span", _hoisted_19, _toDisplayString(getMonthProgress(_ctx.monthData.module)) + "% ", 1)
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["h-3 rounded-full transition-all duration-300", getProgressBarColor(_ctx.monthData.module)]),
                      style: _normalizeStyle({ width: getMonthProgress(_ctx.monthData.module) + '%' })
                    }, null, 6)
                  ]),
                  _createElementVNode("div", _hoisted_21, _toDisplayString(getProgressDescription(_ctx.monthData.module)), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("h4", _hoisted_23, [
                _createVNode(_unref(Info), { class: "w-4 h-4 mr-2 text-emerald-600 dark:text-emerald-400" }),
                _cache[7] || (_cache[7] = _createTextVNode(" Module Status ", -1))
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", {
                  class: _normalizeClass(["w-3 h-3 rounded-full", getModuleStatusColor(_ctx.monthData.module)])
                }, null, 2),
                _createElementVNode("span", {
                  class: _normalizeClass(["text-sm font-medium", getModuleStatusTextColor(_ctx.monthData.module)])
                }, _toDisplayString(getModuleStatusText(_ctx.monthData.module)), 3)
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createVNode(_unref(Calendar), { class: "w-16 h-16 text-slate-400 dark:text-slate-500 mx-auto mb-4" }),
              _cache[8] || (_cache[8] = _createElementVNode("h3", { class: "text-lg font-medium text-slate-700 dark:text-slate-300 mb-2" }, " No Module Assigned ", -1)),
              _createElementVNode("p", _hoisted_27, " No training module is scheduled for " + _toDisplayString(_ctx.monthData?.name) + " " + _toDisplayString(_ctx.year), 1)
            ])
          ])),
      (_ctx.monthData?.module)
        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", null, [
                _createElementVNode("h4", _hoisted_30, [
                  _createVNode(_unref(Users), { class: "w-5 h-5 mr-2 text-primary-accent dark:text-primary-dark-accent" }),
                  _cache[9] || (_cache[9] = _createTextVNode(" Employee Progress ", -1))
                ]),
                _cache[10] || (_cache[10] = _createElementVNode("p", { class: "text-sm text-secondary-text dark:text-secondary-dark-text mt-1" }, " Track employee module assignments and exam progress ", -1))
              ]),
              _createElementVNode("button", {
                onClick: refreshEmployeeProgress,
                disabled: loadingProgress.value,
                class: "px-3 py-2 text-sm bg-primary-accent dark:bg-primary-dark-accent text-white rounded-lg hover:bg-primary-accent/90 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center space-x-2"
              }, [
                _createVNode(_unref(RefreshCw), {
                  class: _normalizeClass(["w-4 h-4", { 'animate-spin': loadingProgress.value }])
                }, null, 8, ["class"]),
                _createElementVNode("span", null, _toDisplayString(loadingProgress.value ? 'Loading...' : 'Refresh'), 1)
              ], 8, _hoisted_31)
            ]),
            (employeeProgress.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, _toDisplayString(employeeProgress.value.summary.employees_with_access), 1),
                    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "text-sm text-blue-600 dark:text-blue-400" }, "Assigned Employees", -1))
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, _toDisplayString(employeeProgress.value.summary.exams_taken), 1),
                    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "text-sm text-emerald-600 dark:text-emerald-400" }, "Exams Taken", -1))
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, _toDisplayString(employeeProgress.value.summary.completion_rate) + "%", 1),
                    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "text-sm text-purple-600 dark:text-purple-400" }, "Completion Rate", -1))
                  ]),
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, _toDisplayString(employeeProgress.value.summary.pass_rate) + "%", 1),
                    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "text-sm text-amber-600 dark:text-amber-400" }, "Pass Rate", -1))
                  ])
                ]))
              : _createCommentVNode("", true),
            (employeeProgress.value && employeeProgress.value.employee_progress.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(employeeProgress.value.employee_progress, (employee) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: employee.employee_id,
                      class: "border border-gray-200 dark:border-gray-700 rounded-xl p-5 hover:shadow-lg hover:border-primary-accent/30 dark:hover:border-primary-dark-accent/30 transition-all duration-200"
                    }, [
                      _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("div", _hoisted_43, [
                          _createElementVNode("div", _hoisted_44, [
                            _createElementVNode("div", _hoisted_45, [
                              (employee.employee.user_image)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: employee.employee.user_image,
                                    alt: employee.employee.user_details?.full_name || 'Employee',
                                    class: "h-full w-full object-cover",
                                    onError: handleImageError
                                  }, null, 40, _hoisted_46))
                                : (employee.employee.user_details)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_47, _toDisplayString(employee.employee.user_details.first_name?.charAt(0) || '') + _toDisplayString(employee.employee.user_details.last_name?.charAt(0) || ''), 1))
                                  : (_openBlock(), _createBlock(_unref(User), {
                                      key: 2,
                                      class: "w-6 h-6 text-primary-accent dark:text-primary-dark-accent"
                                    }))
                            ]),
                            _createElementVNode("div", {
                              class: _normalizeClass(["absolute bottom-1 -right-1 w-4 h-4 rounded-full border-2 border-white dark:border-dark-secondary flex items-center justify-center", employee.has_access ? 'bg-emerald-500' : 'bg-gray-400'])
                            }, [
                              (employee.has_access)
                                ? (_openBlock(), _createBlock(_unref(UserCheck), {
                                    key: 0,
                                    class: "w-2.5 h-2.5 text-white"
                                  }))
                                : (_openBlock(), _createBlock(_unref(UserX), {
                                    key: 1,
                                    class: "w-2.5 h-2.5 text-white"
                                  }))
                            ], 2)
                          ]),
                          _createElementVNode("div", _hoisted_48, [
                            _createElementVNode("h5", _hoisted_49, _toDisplayString(employee.employee.user_details.full_name), 1),
                            _createElementVNode("div", _hoisted_50, [
                              _createVNode(_unref(Mail), { class: "w-4 h-4" }),
                              _createElementVNode("span", null, _toDisplayString(employee.employee.email), 1)
                            ]),
                            (employee.assignment)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                                  _createElementVNode("span", null, "Assigned: " + _toDisplayString(getMonthNames(employee.assignment.accessible_months).join(', ')), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_52, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["flex items-center px-3 py-1.5 rounded-full text-xs font-medium border", [getEmployeeStatusClass(employee), { 'status-completed': employee.progress.exam_passed, 'status-failed': employee.progress.exam_taken && !employee.progress.exam_passed }]])
                          }, [
                            (_openBlock(), _createBlock(_resolveDynamicComponent(getEmployeeStatusIcon(employee)), { class: "status-icon w-3 h-3 mr-2 inline-block" })),
                            _createElementVNode("span", _hoisted_53, _toDisplayString(getEmployeeStatusText(employee)), 1)
                          ], 2)
                        ])
                      ]),
                      (employee.progress.exam_available)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                            _createElementVNode("div", _hoisted_55, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["w-10 h-10 rounded-lg flex items-center justify-center", employee.progress.exam_taken ? 'bg-blue-100 dark:bg-blue-900/30' : 'bg-gray-100 dark:bg-gray-800'])
                              }, [
                                (!employee.progress.exam_taken)
                                  ? (_openBlock(), _createBlock(_unref(Clock3), {
                                      key: 0,
                                      class: "w-5 h-5 text-gray-500 dark:text-gray-400"
                                    }))
                                  : (employee.progress.exam_passed)
                                    ? (_openBlock(), _createBlock(_unref(CheckCircle2), {
                                        key: 1,
                                        class: "w-5 h-5 text-emerald-600 dark:text-emerald-400"
                                      }))
                                    : (_openBlock(), _createBlock(_unref(XCircle), {
                                        key: 2,
                                        class: "w-5 h-5 text-red-500 dark:text-red-400"
                                      }))
                              ], 2),
                              _createElementVNode("div", null, [
                                _createElementVNode("div", _hoisted_56, _toDisplayString(employee.progress.exam_taken ? 'Exam Completed' : 'Exam Pending'), 1),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["text-xs", !employee.progress.exam_taken ? 'text-gray-500 dark:text-gray-400' : 
                              employee.progress.exam_passed ? 'text-emerald-600 dark:text-emerald-400' : 
                              'text-red-500 dark:text-red-400'])
                                }, _toDisplayString(!employee.progress.exam_taken ? 'Not attempted yet' : 
                          employee.progress.exam_passed ? 'Successfully passed' : 'Did not pass'), 3)
                              ])
                            ]),
                            (employee.progress.latest_score)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["w-10 h-10 rounded-lg flex items-center justify-center", employee.progress.latest_score.passed ? 'bg-emerald-100 dark:bg-emerald-900/30' : 'bg-red-100 dark:bg-red-900/30'])
                                  }, [
                                    _createVNode(_unref(Target), {
                                      class: _normalizeClass(["w-5 h-5", employee.progress.latest_score.passed ? 'text-emerald-600 dark:text-emerald-400' : 'text-red-500 dark:text-red-400'])
                                    }, null, 8, ["class"])
                                  ], 2),
                                  _createElementVNode("div", null, [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["text-lg font-bold", employee.progress.latest_score.passed ? 'text-emerald-600 dark:text-emerald-400' : 'text-red-500 dark:text-red-400'])
                                    }, _toDisplayString(employee.progress.latest_score.percentage) + "% ", 3),
                                    _createElementVNode("div", _hoisted_58, _toDisplayString(formatScore(employee.progress.latest_score.score)) + "/" + _toDisplayString(formatScore(employee.progress.latest_score.total)) + " Score ", 1)
                                  ])
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                  _createElementVNode("div", _hoisted_60, [
                                    _createVNode(_unref(Target), { class: "w-5 h-5 text-gray-400" })
                                  ]),
                                  _cache[15] || (_cache[15] = _createElementVNode("div", null, [
                                    _createElementVNode("div", { class: "text-sm text-gray-500 dark:text-gray-400" }, "No Score"),
                                    _createElementVNode("div", { class: "text-xs text-gray-400" }, "Not attempted")
                                  ], -1))
                                ])),
                            _createElementVNode("div", _hoisted_61, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["w-10 h-10 rounded-lg flex items-center justify-center", employee.progress.attempts > 0 ? 'bg-purple-100 dark:bg-purple-900/30' : 'bg-gray-100 dark:bg-gray-800'])
                              }, [
                                _createVNode(_unref(TrendingUp), {
                                  class: _normalizeClass(["w-5 h-5", employee.progress.attempts > 0 ? 'text-purple-600 dark:text-purple-400' : 'text-gray-400'])
                                }, null, 8, ["class"])
                              ], 2),
                              _createElementVNode("div", null, [
                                _createElementVNode("div", _hoisted_62, _toDisplayString(employeeProgress.value?.module?.exam?.total_attempts 
                        ? `${employee.progress.attempts}/${employeeProgress.value.module.exam.total_attempts}` 
                        : employee.progress.attempts), 1),
                                _createElementVNode("div", _hoisted_63, _toDisplayString(employee.progress.attempts === 1 ? 'Attempt' : 'Attempts'), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_64, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["w-10 h-10 rounded-lg flex items-center justify-center", employee.progress.exam_passed ? 'bg-amber-100 dark:bg-amber-900/30' : 'bg-gray-100 dark:bg-gray-800'])
                              }, [
                                _createVNode(_unref(Award), {
                                  class: _normalizeClass(["w-5 h-5", employee.progress.exam_passed ? 'text-amber-600 dark:text-amber-400' : 'text-gray-400'])
                                }, null, 8, ["class"])
                              ], 2),
                              _createElementVNode("div", _hoisted_65, [
                                _createElementVNode("div", _hoisted_66, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["text-sm font-medium", employee.progress.exam_passed ? 'text-amber-600 dark:text-amber-400' : 'text-gray-500 dark:text-gray-400'])
                                  }, _toDisplayString(employee.progress.exam_passed ? 'Certified' : 'Not Certified'), 3),
                                  _createVNode(BaseTooltip, {
                                    text: getCertificationTooltip(employee),
                                    position: "left",
                                    "trigger-class": "text-sky-500 dark:text-sky-400"
                                  }, null, 8, ["text"])
                                ]),
                                _createElementVNode("div", _hoisted_67, _toDisplayString(employee.progress.exam_passed ? 'Requirements met' : employee.progress.exam_taken ? 'Failed exam' : 'Pending completion'), 1)
                              ])
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_68, [
                            _createElementVNode("div", _hoisted_69, [
                              _createVNode(_unref(AlertCircle), { class: "w-5 h-5" }),
                              _cache[16] || (_cache[16] = _createElementVNode("span", { class: "text-sm" }, "No exam available for this module", -1))
                            ])
                          ]))
                    ]))
                  }), 128))
                ]))
              : (employeeProgress.value && employeeProgress.value.employee_progress.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                    _createElementVNode("div", _hoisted_71, [
                      _createVNode(_unref(Users), { class: "w-16 h-16 text-slate-400 dark:text-slate-500 mx-auto mb-4" }),
                      _cache[17] || (_cache[17] = _createElementVNode("h5", { class: "text-lg font-medium text-slate-700 dark:text-slate-300 mb-2" }, " No Employees Assigned ", -1)),
                      _createElementVNode("p", _hoisted_72, " No employees are currently assigned to this module for " + _toDisplayString(_ctx.monthData?.name) + " " + _toDisplayString(_ctx.year), 1)
                    ])
                  ]))
                : (loadingProgress.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_73, [...(_cache[18] || (_cache[18] = [
                      _createElementVNode("div", { class: "bg-gradient-to-br from-blue-50 to-indigo-50 dark:from-blue-900/20 dark:to-indigo-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-8" }, [
                        _createElementVNode("div", { class: "animate-spin w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full mx-auto mb-4" }),
                        _createElementVNode("h5", { class: "text-lg font-medium text-blue-700 dark:text-blue-300 mb-2" }, " Loading Employee Progress... "),
                        _createElementVNode("p", { class: "text-sm text-blue-600 dark:text-blue-400" }, " Fetching employee assignments and exam results ")
                      ], -1)
                    ]))]))
                  : (progressError.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                        _createElementVNode("div", _hoisted_75, [
                          _createVNode(_unref(AlertCircle), { class: "w-16 h-16 text-red-400 dark:text-red-500 mx-auto mb-4" }),
                          _cache[19] || (_cache[19] = _createElementVNode("h5", { class: "text-lg font-medium text-red-700 dark:text-red-300 mb-2" }, " Failed to Load Progress ", -1)),
                          _createElementVNode("p", _hoisted_76, _toDisplayString(progressError.value), 1),
                          _createElementVNode("button", {
                            onClick: refreshEmployeeProgress,
                            class: "px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
                          }, " Try Again ")
                        ])
                      ]))
                    : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["is-visible", "title", "icon"]))
}
}

})